import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { OtpComponent, RoundCard, RunnerUpHeader, UnderLine } from '../../../ui'
import Button from '../../../library/components/Button'
import './returningOfficer.css'
import { useGenerateEpbPinAndIdQuery, useOtpSendForEtpbmsMutation, useOtpVerifyForEtpbmsMutation } from '../../../services/finalizeGenerateViewTransmitService'
import { parseJwt } from '../../utilities/utils'
import ConfirmationModal from '../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal'
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'
const GenerateEpbPin = ({ onSuccess,onShowModal,number,message,onConfirm , module , showConfirmationBox }) => {
  const [otp, setOtp] = useState('')
  const [btn, setbtn] = useState(true)
  const [otpsend, datap] = useOtpSendForEtpbmsMutation()
  const [verifyOtp, datac] = useOtpVerifyForEtpbmsMutation()
  const [showOtpModal, setShowOtpModal] = useState(true)
  const [showConfirmation, setShowConfirmation] = useState(false)

  const officerId = parseJwt(localStorage?.access_token)?.preferred_username

  useEffect(() => {
    otpsend({
      "userId":officerId,
      "module":module
    }).unwrap().then().catch(()=>onShowModal())
  }, [])


  useEffect(() => {
    if (datac.isSuccess) {
      setShowOtpModal(false)
      setbtn(false)
      setShowConfirmation(true)
      // onShowModal()
    }
  }, [datac.isSuccess])

  const verifyOTP = () => {
    if (otp && otp !== '') {
      verifyOtp({
        "otp":otp,
        userId:officerId,
        module:module
      })
    }
  }

  return (
    <div className="container box">
      <div className="generate-epb col-md-12">
        {showOtpModal && (
          <>
            <RunnerUpHeaderNew title={'Verify OTP to proceed'} />
            <p>
              Please enter the OTP received on your Mobile number +91 - {number}{`${' '}`}
              to {message}
            </p>
            <OtpComponent setOtp={setOtp} otp={otp} />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '15px',
              }}
            >
              <Button
                btnClass="verify-btn"
                value="Verify otp"
                disabled={otp.length < 6 || datac.isSuccess}
                onClick={verifyOTP}
              />
            </div>
          </>
        )}
        {showConfirmation &&showConfirmationBox && (
          <>
            <ConfirmationModal
              yesOption={()=>{onConfirm()}}
              noOption={() => {
                onShowModal()
              }}
              title={`Are you sure you want to ${message} ?`}
            />
            {/* <p>Are you sure you want to Transmit e-PB Pin?</p>
            <Button
              value="Verify OTP & generate e-pb pin"
              onClick={generateEpbPin}
              disabled={btn}
            /> */}
            {/* <Button value='Verify OTP & generate e-pb pin' btnClass='verify-btn'/> */}
          </>
        )}
      </div>
    </div>
  )
}
export default GenerateEpbPin
